const desserts = [

    {   name: "Млинці «Малібу»", 
        category: 'Десерти', 
        unit: ' г', 
        amount: '170/10', 
        price: 200, 
        image: "",
        ingredients: ''  
    },

    {   name: "Млинці з шоколадним кремом «Nutella»", 
        category: 'Десерти', 
        unit: ' г', 
        amount: '170/15/15', 
        price: 180, 
        image: "",
        ingredients: ''  
    },

    {   name: "Млинці з сиром та родзинками", 
        category: 'Десерти', 
        unit: ' г', 
        amount: 200, 
        price: 160, 
        image: "",
        ingredients: ''  
    },

    {   name: "Млинці з вишнями та маком", 
        category: 'Десерти', 
        unit: ' г', 
        amount: 200, 
        price: 180, 
        image: "",
        ingredients: ''  
    },
    
    { name: "Млинці «Вишиванка»", 
        category: 'Десерти', 
        unit: ' г', 
        amount: 220, 
        price: 280, 
        image: "/images/Mlyntsi_Vyshyvanka.jpg",
        ingredients: '(маскарпоне, мак, вишня)' 
    },

    {   name: "Млинці з вишнями та вершками", 
        category: 'Десерти', 
        unit: ' г', 
        amount: '220/50', 
        price: 180, 
        image: "",
        ingredients: ''  
    },

    {   name: "Млинці шоколадні з маскарпоне і фініками", 
        category: 'Десерти', 
        unit: ' г', 
        amount: 220, 
        price: 180, 
        image: "",
        ingredients: ''  
    },

    { name: "Фірмові шоколадні млинці «Буржуй»", 
        category: 'Десерти', 
        unit: ' г', 
        amount: 190, 
        price: 180, 
        image: "/images/Mlyntsi_Burzhui.jpg",
        ingredients: '(вершковий сир, желе)'  
    },

    {   name: "Млинці з маскарпоне і малиною", 
        category: 'Десерти', 
        unit: ' г', 
        amount: 220, 
        price: 180, 
        image: "",
        ingredients: ''  
    },

    {   name: "Млинці з яблуками із заварним кремом", 
        category: 'Десерти', 
        unit: ' г', 
        amount: 220, 
        price: 180, 
        image: "",
        ingredients: ''  
    },

    {   name: "Млинці шоколадні з сиром та чорницею", 
        category: 'Десерти', 
        unit: ' г', 
        amount: 260, 
        price: 180, 
        image: "",
        ingredients: ''  
    },

    {   name: "Млинці Снікерс", 
        category: 'Десерти', 
        unit: ' г', 
        amount: 200, 
        price: 180, 
        image: "",
        ingredients: '(сир філадельфія, згущене молоко, арахіс, грецький горіх)'  
    },

    { name: "Млинці «Весільні»", 
        category: 'Десерти', 
        unit: ' г', 
        amount: 250, 
        price: 200, 
        image: "/images/Mlyntsi_Vesilni.jpg",
        ingredients: '(творог домашній, кориця, цукор, вершки)'  
    },

    {   name: "Асорті сухофруктів з вершками", 
        category: 'Десерти', 
        unit: ' г', 
        amount: 140, 
        price: 200, 
        image: "",
        ingredients: '(чорнослив, фініки та курага)'  
    },

    {   name: "Чорнослив з вершками", 
        category: 'Десерти', 
        unit: ' г', 
        amount: 140, 
        price: 180, 
        image: "",
        ingredients: ''  
    }, 

];

export default desserts;